import { Fragment, useState } from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
// import Clock from "react-live-clock";
const Clock = dynamic(() => import("react-live-clock"), { ssr: false });
import ct from "countries-and-timezones";

import { kelvinToCelsius, kelvinToFahrenheit } from "utils";
import { weatherIcons } from "utils/weatherIcons";

import styles from "./BasicWeatherWidget.module.scss";

export default function BasicWeatherWidget({
  destination,
  countryDetail,
  loading,
  destinationWeather,
}) {
  const countryTime = ct.getCountry(
    destination?.destination_details?.country_short_code?.toUpperCase()
  );
  const timeZone = countryTime?.timezones[0] || "US/Pacific";

  const [C, K] = ["C", "K"];
  const [tempScale, setTempScale] = useState(C);

  const weatherC =
    Math.floor(
      parseFloat(kelvinToCelsius(destinationWeather?.main?.temp))
    ).toString() || "";
  const weatherK =
    Math.floor(
      parseFloat(kelvinToFahrenheit(destinationWeather?.main?.temp))
    ).toString() || "";
  const weatherIcon = destinationWeather?.weather?.[0]?.icon || "04n";
  const weatherDescription = destinationWeather?.weather?.[0]?.description;

  return (
    <div className={`${styles.weatherInfo}`}>
      <div className={`${styles.labelImageContainer}`}>
        <div className={`${styles.cityWeather}`}>
          {countryDetail?.capital}{" "}
          <span className={`${styles.weatherDescription}`}>
            {weatherDescription}
          </span>
        </div>

        <div className={`${styles.weatherImageWrapper}`}>
          {weatherIcons.map((item) => (
            <Fragment key={`${item.id}-${item.description.split(" ")[0]}`}>
              {item.id === weatherIcon && (
                <Image src={item.icon} alt="Temp icon" fill />
              )}
            </Fragment>
          ))}
        </div>
      </div>
      <div className={`${styles.timeWrapper}`}>
        {Object.keys(destinationWeather).length > 0 && (
          <WeatherCK
            weatherOptions={{
              tempScale,
              setTempScale,
              weatherC,
              weatherK,
              weatherIcon,
              loading,
              C,
              K,
            }}
          />
        )}
        <span className={`${styles.clockWrapper}`}>
          <Clock
            format={"hh:mm"}
            timezone={`${timeZone}`}
            ticking={true}
            noSsr={true}
          />
          <span>
            {" "}
            <Clock format={"a"} timezone={`${timeZone}`} noSsr={true} />
          </span>
        </span>
      </div>
    </div>
  );
}

function WeatherCK({ weatherOptions }) {
  const { tempScale, setTempScale, weatherC, weatherK, loading, C, K } =
    weatherOptions;

  function toggleTempScale() {
    if (tempScale === C) {
      setTempScale(K);
    } else {
      setTempScale(C);
    }
  }

  return (
    <>
      {(weatherC || weatherK) && (
        <div className={`${styles.weatherComponent}`}>
          {loading && "..."}
          {!loading &&
            (tempScale === C && tempScale !== K
              ? weatherC + "° "
              : weatherK + "° ")}
          <span
            onClick={toggleTempScale}
            className={`${styles.scale} ${
              tempScale === C ? styles.active : ""
            }`}
          >
            C
          </span>
          <span>|</span>
          <span
            className={`${styles.scale} ${
              tempScale === K ? styles.active : ""
            }`}
            onClick={toggleTempScale}
          >
            F
          </span>
        </div>
      )}
    </>
  );
}
